import styled from '@emotion/styled';
import xw from 'xwind';

export const Title = styled.h1(
  xw`
    text-3xl text-active
    tracking-wider
    text-center 
    md[text-4xl]
  `,
);

export const Line = styled.hr(
  xw`
    mb-6 border w-32 sm:w-40
    border-secondary
    mx-auto mb-10 mt-10
    md[mt-4 mb-24]
  `,
);

export const TitleSection = styled.h2(
  xw`
    text-2xl mb-4
    md[text-3xl]
  `,
);

export const TextSection = styled.p(
  xw`
    text-lg text-gray-700
    md[text-xl]
  `,
);
